import React, { useState } from 'react';
import { Search, Filter, Plus, Download, Printer, Edit2, Trash2, MoreVertical, AlertCircle, CheckCircle2, Clock, Tag, Layers, MapPin, Truck, DollarSign } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Calendar } from 'lucide-react';
export type InventoryItem = {
  id: string;
  item: string;
  category: string;
  countLocation: string;
  vendor: string;
  openQty: number;
  unitType: string;
  caseCount: number;
  unitCountCost: number;
  caseCountCost: number;
  onHand: number;
  par: number;
  order: number;
  orderCost: number;
  approved: boolean;
  submitted: boolean;
  received: boolean;
  deliveryDate: string;
  outOfStock: boolean;
  misPic: string;
  result: string;
};
const initialItems: InventoryItem[] = [{
  id: '1',
  item: 'Atlantic Salmon',
  category: 'Food Master',
  countLocation: 'Walk In',
  vendor: 'Profish',
  openQty: 10,
  unitType: 'Pound',
  caseCount: 10,
  unitCountCost: 18.5,
  caseCountCost: 185,
  onHand: 4,
  par: 15,
  order: 11,
  orderCost: 203.5,
  approved: false,
  submitted: false,
  received: false,
  deliveryDate: '',
  outOfStock: false,
  misPic: '',
  result: ''
}, {
  id: '2',
  item: 'Grey Goose',
  category: 'Liquor Master',
  countLocation: 'Liquor Room',
  vendor: 'Washington Wholesales',
  openQty: 5,
  unitType: 'Bottle',
  caseCount: 12,
  unitCountCost: 25,
  caseCountCost: 300,
  onHand: 2,
  par: 12,
  order: 10,
  orderCost: 250,
  approved: true,
  submitted: true,
  received: false,
  deliveryDate: '2025-01-15',
  outOfStock: false,
  misPic: '',
  result: ''
}, {
  id: '3',
  item: 'Oysters',
  category: 'Food Master',
  countLocation: 'Walk In',
  vendor: 'Profish',
  openQty: 50,
  unitType: 'Each',
  caseCount: 100,
  unitCountCost: 1.5,
  caseCountCost: 150,
  onHand: 2,
  par: 10,
  order: 8,
  orderCost: 12,
  approved: false,
  submitted: false,
  received: false,
  deliveryDate: '',
  outOfStock: true,
  misPic: '',
  result: ''
}];
export function ItemMaster() {
  const [items, setItems] = useState<InventoryItem[]>(initialItems);
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('All');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newItem, setNewItem] = useState<Partial<InventoryItem>>({
    category: 'Food Master',
    countLocation: 'Walk In',
    unitType: 'Each',
    vendor: 'Profish',
    openQty: 0,
    caseCount: 1,
    unitCountCost: 0,
    caseCountCost: 0,
    onHand: 0,
    par: 0,
    order: 0,
    orderCost: 0,
    approved: false,
    submitted: false,
    received: false,
    outOfStock: false
  });
  const handleAddItem = () => {
    const id = Math.random().toString(36).substr(2, 9);
    setItems([...items, {
      ...newItem,
      id
    } as InventoryItem]);
    setIsModalOpen(false);
    setNewItem({
      category: 'Food Master',
      countLocation: 'Walk In',
      unitType: 'Each',
      vendor: 'Profish',
      openQty: 0,
      caseCount: 1,
      unitCountCost: 0,
      caseCountCost: 0,
      onHand: 0,
      par: 0,
      order: 0,
      orderCost: 0,
      approved: false,
      submitted: false,
      received: false,
      outOfStock: false
    });
  };
  const filteredItems = items.filter(item => {
    const matchesSearch = item.item.toLowerCase().includes(search.toLowerCase()) || item.vendor.toLowerCase().includes(search.toLowerCase());
    if (filter === 'All') return matchesSearch;
    if (filter === 'Below PAR') return matchesSearch && item.onHand < item.par;
    if (filter === 'Out of Stock') return matchesSearch && item.outOfStock;
    if (filter === 'Pending Orders') return matchesSearch && item.submitted && !item.received;
    return matchesSearch && (item.category === filter || item.countLocation === filter);
  });
  return <div className="space-y-6" data-id="element-467">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-468">
        <div className="flex items-center gap-4 flex-1 max-w-2xl" data-id="element-469">
          <div className="relative flex-1" data-id="element-470">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} data-id="element-471" />
            <input type="text" placeholder="Search items or vendors..." value={search} onChange={e => setSearch(e.target.value)} className="w-full pl-10 pr-4 py-2 bg-white border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 outline-none transition-all" data-id="element-472" />
          </div>
          <select value={filter} onChange={e => setFilter(e.target.value)} className="px-4 py-2 bg-white border border-slate-200 rounded-xl text-sm font-medium outline-none focus:ring-2 focus:ring-emerald-500/20" data-id="element-473">
            <option data-id="element-474">All</option>
            <option data-id="element-475">Below PAR</option>
            <option data-id="element-476">Out of Stock</option>
            <option data-id="element-477">Pending Orders</option>
            <optgroup label="Categories" data-id="element-478">
              <option data-id="element-479">Food Master</option>
              <option data-id="element-480">Liquor Master</option>
              <option data-id="element-481">Beer & Wine Master</option>
            </optgroup>
          </select>
        </div>
        <div className="flex items-center gap-2" data-id="element-482">
          <button className="p-2 bg-white border border-slate-200 rounded-xl text-slate-600 hover:bg-slate-50 transition-all shadow-sm" data-id="element-483">
            <Printer size={18} data-id="element-484" />
          </button>
          <button className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-200 rounded-xl text-sm font-bold text-slate-600 hover:bg-slate-50 transition-all shadow-sm" data-id="element-485">
            <Download size={16} data-id="element-486" />
            Export
          </button>
          <button onClick={() => setIsModalOpen(true)} className="flex items-center gap-2 px-4 py-2 bg-emerald-500 text-white rounded-xl text-sm font-bold hover:bg-emerald-600 transition-all shadow-lg shadow-emerald-500/20" data-id="element-487">
            <Plus size={16} data-id="element-488" />
            Add Item
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-489">
        {isModalOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm" data-id="element-490">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="bg-white rounded-3xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col" data-id="element-491">
              <div className="px-8 py-6 border-b border-slate-100 flex items-center justify-between bg-slate-50/50" data-id="element-492">
                <div data-id="element-493">
                  <h3 className="text-xl font-bold text-slate-900" data-id="element-494">
                    Add New Inventory Item
                  </h3>
                  <p className="text-sm text-slate-500 font-medium" data-id="element-495">
                    Enter product details and stock parameters
                  </p>
                </div>
                <button onClick={() => setIsModalOpen(false)} className="p-2 hover:bg-slate-200 rounded-full transition-colors text-slate-400 hover:text-slate-600" data-id="element-496">
                  <X size={20} data-id="element-497" />
                </button>
              </div>

              <div className="flex-1 overflow-y-auto p-8" data-id="element-498">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-499">
                  {/* Basic Info */}
                  <div className="md:col-span-3" data-id="element-500">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-501">
                      Item Name
                    </label>
                    <input type="text" placeholder="e.g. Atlantic Salmon" className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" value={newItem.item || ''} onChange={e => setNewItem({
                  ...newItem,
                  item: e.target.value
                })} data-id="element-502" />
                  </div>

                  <div data-id="element-503">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-504">
                      Category
                    </label>
                    <select className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" value={newItem.category} onChange={e => setNewItem({
                  ...newItem,
                  category: e.target.value
                })} data-id="element-505">
                      <option data-id="element-506">Food Master</option>
                      <option data-id="element-507">Liquor Master</option>
                      <option data-id="element-508">N/A Beverage Master</option>
                      <option data-id="element-509">Beer & Wine Master</option>
                      <option data-id="element-510">Paper & Plastic Master</option>
                    </select>
                  </div>

                  <div data-id="element-511">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-512">
                      Count Location
                    </label>
                    <select className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" value={newItem.countLocation} onChange={e => setNewItem({
                  ...newItem,
                  countLocation: e.target.value
                })} data-id="element-513">
                      <option data-id="element-514">Walk In</option>
                      <option data-id="element-515">Prep Station</option>
                      <option data-id="element-516">Freezer 1</option>
                      <option data-id="element-517">Freezer 2</option>
                      <option data-id="element-518">Fry Stations</option>
                      <option data-id="element-519">Expedite Stations</option>
                      <option data-id="element-520">Sautee Oven Station</option>
                      <option data-id="element-521">Expo Station</option>
                      <option data-id="element-522">Dish Area</option>
                      <option data-id="element-523">Liquor Room</option>
                      <option data-id="element-524">Liquor Cage</option>
                      <option data-id="element-525">Main Bar</option>
                      <option data-id="element-526">Bar Cooler 1</option>
                      <option data-id="element-527">Bar Cooler 2</option>
                    </select>
                  </div>

                  <div data-id="element-528">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-529">
                      Vendor
                    </label>
                    <select className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" value={newItem.vendor} onChange={e => setNewItem({
                  ...newItem,
                  vendor: e.target.value
                })} data-id="element-530">
                      <option data-id="element-531">Profish</option>
                      <option data-id="element-532">Washington Wholesales</option>
                      <option data-id="element-533">Sysco</option>
                      <option data-id="element-534">US Foods</option>
                      <option data-id="element-535">Local Farmers</option>
                    </select>
                  </div>

                  {/* Stock Parameters */}
                  <div data-id="element-536">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-537">
                      Unit Type
                    </label>
                    <select className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" value={newItem.unitType} onChange={e => setNewItem({
                  ...newItem,
                  unitType: e.target.value
                })} data-id="element-538">
                      <option data-id="element-539">Each</option>
                      <option data-id="element-540">Pound</option>
                      <option data-id="element-541">Ounce</option>
                      <option data-id="element-542">Case</option>
                      <option data-id="element-543">Bottle</option>
                      <option data-id="element-544">Gallon</option>
                      <option data-id="element-545">Liter</option>
                    </select>
                  </div>

                  <div data-id="element-546">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-547">
                      Open Qty
                    </label>
                    <input type="number" className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" value={newItem.openQty} onChange={e => setNewItem({
                  ...newItem,
                  openQty: Number(e.target.value)
                })} data-id="element-548" />
                  </div>

                  <div data-id="element-549">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-550">
                      Case Count (Units/Case)
                    </label>
                    <input type="number" className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" value={newItem.caseCount} onChange={e => setNewItem({
                  ...newItem,
                  caseCount: Number(e.target.value)
                })} data-id="element-551" />
                  </div>

                  <div data-id="element-552">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-553">
                      Unit Count $
                    </label>
                    <div className="relative" data-id="element-554">
                      <DollarSign className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={14} data-id="element-555" />
                      <input type="number" className="w-full pl-8 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" value={newItem.unitCountCost} onChange={e => {
                    const val = Number(e.target.value);
                    setNewItem({
                      ...newItem,
                      unitCountCost: val,
                      caseCountCost: val * (newItem.caseCount || 1)
                    });
                  }} data-id="element-556" />
                    </div>
                  </div>

                  <div data-id="element-557">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-558">
                      Case Count $
                    </label>
                    <div className="relative" data-id="element-559">
                      <DollarSign className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={14} data-id="element-560" />
                      <input type="number" className="w-full pl-8 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" value={newItem.caseCountCost} onChange={e => {
                    const val = Number(e.target.value);
                    setNewItem({
                      ...newItem,
                      caseCountCost: val,
                      unitCountCost: val / (newItem.caseCount || 1)
                    });
                  }} data-id="element-561" />
                    </div>
                  </div>

                  <div data-id="element-562">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-563">
                      On Hand
                    </label>
                    <input type="number" className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" value={newItem.onHand} onChange={e => {
                  const onHand = Number(e.target.value);
                  const par = newItem.par || 0;
                  const order = Math.max(0, par - onHand);
                  setNewItem({
                    ...newItem,
                    onHand,
                    order,
                    orderCost: order * (newItem.unitCountCost || 0)
                  });
                }} data-id="element-564" />
                  </div>

                  <div data-id="element-565">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-566">
                      PAR
                    </label>
                    <input type="number" className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" value={newItem.par} onChange={e => {
                  const par = Number(e.target.value);
                  const onHand = newItem.onHand || 0;
                  const order = Math.max(0, par - onHand);
                  setNewItem({
                    ...newItem,
                    par,
                    order,
                    orderCost: order * (newItem.unitCountCost || 0)
                  });
                }} data-id="element-567" />
                  </div>

                  <div data-id="element-568">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-569">
                      Order Qty (Auto)
                    </label>
                    <input type="number" readOnly className="w-full px-4 py-3 bg-slate-100 border border-slate-200 rounded-xl text-sm text-slate-500 outline-none" value={newItem.order} data-id="element-570" />
                  </div>

                  <div data-id="element-571">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-572">
                      Order $ (Auto)
                    </label>
                    <div className="relative" data-id="element-573">
                      <DollarSign className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={14} data-id="element-574" />
                      <input type="number" readOnly className="w-full pl-8 pr-4 py-3 bg-slate-100 border border-slate-200 rounded-xl text-sm text-slate-500 outline-none" value={newItem.orderCost} data-id="element-575" />
                    </div>
                  </div>

                  {/* Status & Dates */}
                  <div className="md:col-span-3 grid grid-cols-2 md:grid-cols-4 gap-4 py-4 border-y border-slate-100 my-2" data-id="element-576">
                    <label className="flex items-center gap-3 cursor-pointer group" data-id="element-577">
                      <input type="checkbox" className="w-5 h-5 rounded-lg border-slate-300 text-emerald-500 focus:ring-emerald-500/20" checked={newItem.approved} onChange={e => setNewItem({
                    ...newItem,
                    approved: e.target.checked
                  })} data-id="element-578" />
                      <span className="text-sm font-bold text-slate-600 group-hover:text-slate-900 transition-colors" data-id="element-579">
                        Approved
                      </span>
                    </label>
                    <label className="flex items-center gap-3 cursor-pointer group" data-id="element-580">
                      <input type="checkbox" className="w-5 h-5 rounded-lg border-slate-300 text-emerald-500 focus:ring-emerald-500/20" checked={newItem.submitted} onChange={e => setNewItem({
                    ...newItem,
                    submitted: e.target.checked
                  })} data-id="element-581" />
                      <span className="text-sm font-bold text-slate-600 group-hover:text-slate-900 transition-colors" data-id="element-582">
                        Submitted
                      </span>
                    </label>
                    <label className="flex items-center gap-3 cursor-pointer group" data-id="element-583">
                      <input type="checkbox" className="w-5 h-5 rounded-lg border-slate-300 text-emerald-500 focus:ring-emerald-500/20" checked={newItem.received} onChange={e => setNewItem({
                    ...newItem,
                    received: e.target.checked
                  })} data-id="element-584" />
                      <span className="text-sm font-bold text-slate-600 group-hover:text-slate-900 transition-colors" data-id="element-585">
                        Received
                      </span>
                    </label>
                    <label className="flex items-center gap-3 cursor-pointer group" data-id="element-586">
                      <input type="checkbox" className="w-5 h-5 rounded-lg border-slate-300 text-rose-500 focus:ring-rose-500/20" checked={newItem.outOfStock} onChange={e => setNewItem({
                    ...newItem,
                    outOfStock: e.target.checked
                  })} data-id="element-587" />
                      <span className="text-sm font-bold text-slate-600 group-hover:text-slate-900 transition-colors" data-id="element-588">
                        Out of Stock
                      </span>
                    </label>
                  </div>

                  <div data-id="element-589">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-590">
                      Delivery Date
                    </label>
                    <div className="relative" data-id="element-591">
                      <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={14} data-id="element-592" />
                      <input type="date" className="w-full pl-8 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" value={newItem.deliveryDate || ''} onChange={e => setNewItem({
                    ...newItem,
                    deliveryDate: e.target.value
                  })} data-id="element-593" />
                    </div>
                  </div>

                  <div className="md:col-span-2" data-id="element-594">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-595">
                      MIS PIC Notes
                    </label>
                    <input type="text" placeholder="Damaged, wrong item, etc." className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" value={newItem.misPic || ''} onChange={e => setNewItem({
                  ...newItem,
                  misPic: e.target.value
                })} data-id="element-596" />
                  </div>

                  <div className="md:col-span-3" data-id="element-597">
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2" data-id="element-598">
                      Result / Resolution
                    </label>
                    <textarea rows={2} placeholder="Notes on resolution..." className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all resize-none" value={newItem.result || ''} onChange={e => setNewItem({
                  ...newItem,
                  result: e.target.value
                })} data-id="element-599" />
                  </div>
                </div>
              </div>

              <div className="px-8 py-6 border-t border-slate-100 bg-slate-50/50 flex items-center justify-end gap-3" data-id="element-600">
                <button onClick={() => setIsModalOpen(false)} className="px-6 py-2.5 text-sm font-bold text-slate-600 hover:bg-slate-200 rounded-xl transition-all" data-id="element-601">
                  Cancel
                </button>
                <button onClick={handleAddItem} className="px-8 py-2.5 bg-emerald-500 text-white rounded-xl text-sm font-bold hover:bg-emerald-600 transition-all shadow-lg shadow-emerald-500/20" data-id="element-602">
                  Add Item to Master
                </button>
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>

      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden" data-id="element-603">
        <div className="overflow-x-auto" data-id="element-604">
          <table className="w-full text-left border-collapse" data-id="element-605">
            <thead data-id="element-606">
              <tr className="bg-slate-50/50 border-b border-slate-100" data-id="element-607">
                <th className="px-4 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-608">
                  Item
                </th>
                <th className="px-4 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-609">
                  Category
                </th>
                <th className="px-4 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-610">
                  Location
                </th>
                <th className="px-4 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-611">
                  Vendor
                </th>
                <th className="px-4 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-612">
                  On Hand
                </th>
                <th className="px-4 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-613">
                  PAR
                </th>
                <th className="px-4 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-614">
                  Order
                </th>
                <th className="px-4 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-615">
                  Status
                </th>
                <th className="px-4 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest text-right" data-id="element-616">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50" data-id="element-617">
              {filteredItems.map(item => <tr key={item.id} className="hover:bg-slate-50/50 transition-colors group" data-id="element-618">
                  <td className="px-4 py-4" data-id="element-619">
                    <div className="flex flex-col" data-id="element-620">
                      <span className="text-sm font-bold text-slate-900" data-id="element-621">
                        {item.item}
                      </span>
                      <span className="text-[10px] text-slate-400 font-medium" data-id="element-622">
                        {item.unitType}
                      </span>
                    </div>
                  </td>
                  <td className="px-4 py-4" data-id="element-623">
                    <span className="px-2 py-1 bg-slate-100 text-slate-600 text-[10px] font-bold rounded-md uppercase" data-id="element-624">
                      {item.category.replace(' Master', '')}
                    </span>
                  </td>
                  <td className="px-4 py-4 text-xs font-medium text-slate-500" data-id="element-625">
                    {item.countLocation}
                  </td>
                  <td className="px-4 py-4 text-xs font-medium text-slate-600" data-id="element-626">
                    {item.vendor}
                  </td>
                  <td className="px-4 py-4" data-id="element-627">
                    <span className={`text-sm font-black ${item.onHand < item.par ? 'text-rose-600' : 'text-slate-900'}`} data-id="element-628">
                      {item.onHand}
                    </span>
                  </td>
                  <td className="px-4 py-4 text-sm font-bold text-slate-500" data-id="element-629">
                    {item.par}
                  </td>
                  <td className="px-4 py-4" data-id="element-630">
                    {item.order > 0 && <div className="flex flex-col" data-id="element-631">
                        <span className="text-sm font-black text-emerald-600" data-id="element-632">
                          +{item.order}
                        </span>
                        <span className="text-[10px] text-slate-400 font-bold" data-id="element-633">
                          ${item.orderCost}
                        </span>
                      </div>}
                  </td>
                  <td className="px-4 py-4" data-id="element-634">
                    <div className="flex flex-wrap gap-1" data-id="element-635">
                      {item.outOfStock && <span className="px-1.5 py-0.5 bg-rose-50 text-rose-600 text-[8px] font-black rounded uppercase border border-rose-100" data-id="element-636">
                          OOS
                        </span>}
                      {item.submitted && !item.received && <span className="px-1.5 py-0.5 bg-blue-50 text-blue-600 text-[8px] font-black rounded uppercase border border-blue-100" data-id="element-637">
                          Ordered
                        </span>}
                      {item.received && <span className="px-1.5 py-0.5 bg-emerald-50 text-emerald-600 text-[8px] font-black rounded uppercase border border-emerald-100" data-id="element-638">
                          Received
                        </span>}
                    </div>
                  </td>
                  <td className="px-4 py-4 text-right" data-id="element-639">
                    <div className="flex items-center justify-end gap-1 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-640">
                      <button className="p-1.5 text-slate-400 hover:text-emerald-600 transition-colors" data-id="element-641">
                        <Edit2 size={14} data-id="element-642" />
                      </button>
                      <button className="p-1.5 text-slate-400 hover:text-rose-600 transition-colors" data-id="element-643">
                        <Trash2 size={14} data-id="element-644" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}